module.exports = __webpack_public_path__ + "static/img/29_car.4f0f3820.jpg";